import { createRoot } from 'react-dom/client';
import ErrorBoundary from '@components/error-boundary/ErrorBoundary';
import { Provider } from 'react-redux';
import { store } from '@store/store';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import loadTranslations from '@translations/functions';
import { RouterProvider } from 'react-router';
import { router } from '@features/routing/createRouter';
import TagManager from 'react-gtm-module';
import AuthComponent from '@features/authentication/AuthComponent';
import { I18nProvider } from 'react-aria-components';
import { getLanguageTag } from '@translations/functions';
import '@styles/main.scss';



TagManager.initialize({ gtmId: process.env.GTM_ID });



const Root = () => {
	loadTranslations();
	
	return (
		<ErrorBoundary>
			<Provider store={store}>
				<I18nextProvider i18n={i18next}>
					<I18nProvider locale={getLanguageTag()}>
						<AuthComponent />
						<RouterProvider router={router} />
					</I18nProvider>
				</I18nextProvider>
			</Provider>
		</ErrorBoundary>
	);
};

const root = createRoot(document.getElementById('root')!);
root.render(<Root />);